module.exports = __webpack_public_path__ + "static/img/man.b2fa81f5.svg";